import { Form } from '@ant-design/compatible'
import { getMerchantInfo } from '@util'
import { message, Modal, Spin } from 'hljd'
import { toJS } from 'mobx'
import { observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import { formatCaseContent } from './common/CaseDetail/utils'
import CheckInputStore from './common/CheckInput/store'
import SuccessModal from './common/TipModal'
import BaseInfo from './components/BaseInfo'
import DetailInfo from './components/DetailInfo'
import Footer from './components/Footer'
import InstanceAuth from './components/InstanceAuth'
import RightBar from './components/RightBar'
import TagsInfo from './components/TagsInfo'
import TopAlert from './components/TopAlert'
import Store from './store'
import ContentStore from './store/contentStore'
import styles from './style.module.less'
import { isChangeCaseDetail } from './utils'

let isChanged = false
@Form.create({
  onValuesChange: () => {
    isChanged = true
  }
})
@observer
class WeddingPlanning extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.contentStore = new ContentStore()
    this.canLeave = false // 当前路由页是否可以直接离开，不需要message提示确认
  }

  // 普通保存的时候有个延时，主要是为了检验敏感词
  // 保存草稿的时候，不需要检验敏感词，直接提交
  handleSubmit = async (type, immediate = false) => {
    if (this.store.submitting) {
      return
    }
    this.store.setStoreData('submitting', true)
    // 取消输入框的焦点
    document.getElementById('root').focus()
    if (immediate) {
      await this.submitFn(type)
    } else {
      setTimeout(() => {
        this.submitFn(type)
      }, 500)
    }
  }

  submitFn = async type => {
    this.store.setStoreData('isChanged', !!isChanged || this.store.isChanged)

    isChanged = false

    const shop_title = this.props.form.getFieldValue('title')
    const cityCode = (getMerchantInfo() || {}).city_code
    const set_meal_detail = this.contentStore.list
    if (cityCode == -2000 && shop_title && !/测试/.test(shop_title)) {
      Modal.error({
        title: '钓鱼岛商家套餐和案例必须带有“测试”词语'
      })
      this.store.setStoreData('submitting', false)
      return
    }
    if (type == 'draft') {
      const check = await CheckInputStore.checkAll()
      if (check) {
        message.error('请检查敏感词')
        this.store.setStoreData('submitting', false)
        return
      }
      const values = this.props.form.getFieldsValue()
      await this.store.submitForm({ ...values, set_meal_detail }, type)
      this.store.setStoreData('submitting', false)
      return
    }

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        // 检验敏感词
        const check = await CheckInputStore.checkAll()
        if (check) {
          message.error('请检查敏感词')
          this.store.setStoreData('submitting', false)
          return
        }
        // 案例详细信息

        const data = await this.store.submitForm(
          { ...values, set_meal_detail },
          type
        )
        !!data && SuccessModal(data)
      } else {
        this.store.setStoreData('submitting', false)
      }
    })
  }

  componentDidMount() {
    this.store.initPage(
      this.props.id,
      this.props.propertyId,
      this.props.isFromShuijing,
      this.props.draftId
    )
    this.setAsyncRouteLeaveHook()
  }

  componentWillUnmount() {
    CheckInputStore.reset()
    this.canLeave = false
  }

  // 监听路由变化
  setAsyncRouteLeaveHook = () => {
    const { router, route } = this.props
    router.setRouteLeaveHook(route, nextLocation => {
      !isChangeCaseDetail(
        toJS(this.contentStore.list),
        formatCaseContent(toJS(this.store.case_detail.set_meal_detail))
      ) && (isChanged = true)
      if (this.canLeave) {
        return true
      }
      if (this.store.forceLeave) {
        return true
      }

      const _isChanged = isChanged || this.store.isChanged
      if (_isChanged) {
        this.routerWillLeave(nextLocation)
      }
      return !_isChanged
    })
  }

  // 路由离开前做提示
  routerWillLeave = nextLocation => {
    const { submitting } = this.store
    const { id } = this.props
    if (id) {
      Modal.confirm({
        title: '切换页面发布内容将不会保存，您确定这样操作吗？',
        onOk: () => {
          this.store.setStoreData('needReload', false)
          this.canLeave = true
          hashHistory.push(nextLocation.pathname)
        }
      })
      return
    }
    Modal.confirm({
      title: '是否将该案例保存为草稿?',
      okText: '保存',
      cancelText: '不保存',
      onOk: async () => {
        this.canLeave = true
        this.store.setStoreData('needReload', false)
        await this.handleSubmit('draft', true)
        hashHistory.push(nextLocation.pathname)
      },
      okButtonProps: {
        submitting
      },
      onCancel: async () => {
        this.canLeave = true
        hashHistory.push(nextLocation.pathname)
      }
    })
  }

  render() {
    const { show_form, submitting, grayTestFlag } = this.store
    const { isFromShuijing, form } = this.props

    const loading = !show_form || submitting
    return (
      <>
        <Provider store={this.store} contentStore={this.contentStore}>
          <Spin tip="加载中..." spinning={loading}>
            <div
              className={styles.weddingPlanning}
              style={{ paddingRight: grayTestFlag ? 280 : 0 }}
            >
              <TopAlert />
              {grayTestFlag && <RightBar />}
              <BaseInfo form={form} isFromShuijing={isFromShuijing} />
              <DetailInfo />
              <TagsInfo />
              {grayTestFlag && <InstanceAuth form={form} />}
              <Footer
                handleSubmit={this.handleSubmit}
                isDraft={!!this.props.draftId}
                id={this.props.id}
                draftId={this.props.draftId}
              />
            </div>
          </Spin>
        </Provider>
      </>
    )
  }
}

export default WeddingPlanning
